import React from 'react';
import { Menu, Dropdown, Avatar } from 'antd';
import { QrcodeOutlined, KeyOutlined } from '@ant-design/icons';
import { connect, useDispatch, useSelector } from 'react-redux';
// import { Link } from 'react-router-dom';
import { LogoutOutlined } from '@ant-design/icons';
import Icon from 'components/util-components/Icon';
import { signOut } from 'redux/actions/Auth';

const menuItem = [];

export const NavProfile = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.auth);

  const profileImg = '/img/avatars/thumb-2.png';
  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <Avatar size={45} src={profile?.profilePicture || profileImg} />
          <div className="pl-3">
            <h4 className="mb-0">Email :</h4>
            <span className="text-muted">{profile?.Email}</span>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <a href={el.path}>
                  <Icon className="mr-3" type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </a>
              </Menu.Item>
            );
          })}
          <Menu.Item
            key={menuItem.length + 1}
            onClick={(e) => dispatch(signOut())}
          >
            <span>
              <LogoutOutlined className="mr-3" />
              <span className="font-weight-normal">Sign Out</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown
      placement="bottomRight"
      dropdownRender={() => profileMenu}
      trigger={['click']}
    >
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item>
          <Avatar src={profile?.profilePicture || profileImg} />
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
};

export default connect(null, { signOut })(NavProfile);
